/**
 * 환경변수 타입 안전 export
 *
 * config/ 레이어: workspace-pkg만 import 가능
 */

function getEnvVar(key: string, fallback?: string): string {
  const value = process.env[key] ?? fallback;
  if (value === undefined) {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
}

/** 백엔드 API base URL (개발 시 Next.js rewrite 프록시 경유) */
export const API_BASE_URL = getEnvVar("NEXT_PUBLIC_BACKEND_API_URL", "/api/v1");

/** Channel Talk 플러그인 키 (비어 있으면 초기화 스킵) */
export const CHANNEL_TALK_PLUGIN_KEY = process.env.NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY ?? "";

/** Mixpanel 프로젝트 토큰 (비어 있으면 트래킹 스킵) */
export const MIXPANEL_ACCESS_KEY = process.env.NEXT_PUBLIC_MIXPANEL_ACCESS_KEY ?? "";

/** 현재 환경 */
export const NODE_ENV = process.env.NODE_ENV ?? "development";

/** 개발 환경 여부 */
export const IS_DEV = NODE_ENV === "development";
